import React, { Fragment } from 'react'
import injectSheet from 'react-jss'
import styles from './works-table.styles'
import { Table, HeadCell } from 'pobble-components/dist/table'
import WorkEntry from './work-entry/work-entry.container'
import {
  BulkActionProvider,
  SelectAllButton
} from 'pobble-components/dist/bulk-action'
import BulkActions from './bulk-actions/bulk-actions.container'
import CreateAssessement from '../../dialogs/create-assessment/create-assessment.container'
import { Pagination } from 'pobble-components/dist/pagination'
import Button from 'pobble-components/dist/button'
import octopus from './octopus.png'

const WorksTable = ({
  classes,
  works,
  onSelectAll,
  onDeselectAll,
  noWorks,
  pagination,
  onPageChange,
  pending
}) =>
  noWorks ? (
    <div className={classes.noWorks}>
      <img width="220" src={octopus} alt="No works yet" />
      <p>This pupil doesn't have any works yet.</p>
      <p>
        <Button tall href={'/actions/upload'}>
          Upload work
        </Button>
      </p>
    </div>
  ) : (
    <Fragment>
      <BulkActionProvider entities={works}>
        <Table pending={pending}>
          <thead>
            <tr>
              <HeadCell className={classes.all}>
                <SelectAllButton />
              </HeadCell>
              <HeadCell className={classes.date}>Date</HeadCell>
              <HeadCell className={classes.work}>Work</HeadCell>
              <HeadCell className={classes.left} />
              <HeadCell className={classes.sta}>Independent</HeadCell>
              <HeadCell className={classes.ageGroup}>Age group</HeadCell>
              <HeadCell className={classes.published}>Published</HeadCell>
              <HeadCell className={classes.contextMenuCell}>
                <BulkActions />
              </HeadCell>
            </tr>
          </thead>
          <tbody>
            {works.map(work => (
              <WorkEntry key={work.id} id={work.id} />
            ))}
          </tbody>
        </Table>
      </BulkActionProvider>
      <div className={classes.pagination}>
        <Pagination onPageChange={onPageChange} data={pagination} />
      </div>
      <p className={classes.moreWorks}>
        <Button tall href={'/actions/upload'}>
          Upload more work
        </Button>
      </p>
      <CreateAssessement />
    </Fragment>
  )

export default injectSheet(styles)(WorksTable)
